/* eslint-disable no-await-in-loop */
import localforage from 'localforage';
import { delay } from '@icp/utils';

const store = localforage.createInstance({
  driver: [
    localforage.INDEXEDDB,
    // localforage.WEBSQL, // deprecated
    localforage.LOCALSTORAGE,
  ],
  name: 'icp',
  storeName: 'extension',
});

const CACHE_EXPIRE_TIME = 1000 * 60 * 60 * 24 * 1; // 1 day
const SCHEDULER_TIMEOUT = 1000 * 60 * 5; // 5 minutes
const SCHEDULER_FORCE_SLEEP_TIME = 1000 * 60 * 5; // 5 minutes

async function scanExpiredCache() {
  try {
    const keys = await store.keys();
    const expKeys = keys.filter((key) => key.endsWith('::exp'));
    const cacheKeysMissingExp = keys
      .filter((key) => !key.endsWith('::exp'))
      .filter((key) => !expKeys.includes(`${key}::exp`));
    await Promise.allSettled(cacheKeysMissingExp.map((key) => store.removeItem(key)));
    for (const expireKey of expKeys) {
      const exp = await store.getItem(expireKey);
      if (exp != null && Date.now() > exp) {
        const cacheKey = expireKey.slice(0, '::exp'.length * -1);
        await Promise.allSettled([store.removeItem(expireKey), store.removeItem(cacheKey)]);
      }
      await delay(0);
    }
  } finally {
    await delay(SCHEDULER_FORCE_SLEEP_TIME);
    requestIdleCallback(scanExpiredCache, { timeout: SCHEDULER_TIMEOUT });
  }
}

const requestIdleCallback = window.requestIdleCallback || ((cb) => setTimeout(cb, 0));

requestIdleCallback(scanExpiredCache, { timeout: SCHEDULER_TIMEOUT });

export async function getCache(url) {
  if (!url) return null;
  const cacheKey = url;
  const expireKey = `${cacheKey}::exp`;
  const expireTime = await store.getItem(expireKey);
  if (expireTime == null) return null;
  if (Date.now() >= expireTime) return null;
  return store.getItem(cacheKey);
}

export async function setCache(url, data) {
  if (!url || !data) return;
  const cacheKey = url;
  const expireKey = `${cacheKey}::exp`;
  const expireTime = Date.now() + CACHE_EXPIRE_TIME;
  await Promise.allSettled([store.setItem(cacheKey, data), store.setItem(expireKey, expireTime)]);
}
